export default function ValidateRepeatPasswd(form) {
  let error = {};

  if (!form.email && form.type === 'email') {
    error.email = "Proszę wpisać swój adres e-mail.";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(form.email) && form.type === 'email') {
    error.email = "Proszę wpisać poprawny adres e-mail.";
  }

  if (!form.phone && form.type === 'phone') {
    error.phone = "Proszę wpisać swój numer telefonu.";
  } else if (form.type === 'phone' && !/(^|\W)(\(?(\+|00)?48\)?)?[ -]?\d{3}[ -]?\d{3}[ -]?\d{3}(?!\w)/g.test(form.phone)) {
    error.phone = "Proszę wpisać poprawny numer telefonu.";
  }

  return error;
};